// @core/api/endpoints/activity/update_activity_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateActivitySettingsRequest,
  UpdateActivitySettingsResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Update activity settings
 * Updates the current user's activity and inbox preferences.
 */
export async function UpdateActivitySettings(
  data: UpdateActivitySettingsRequest,
  options?: RequestOptions
): Promise<UpdateActivitySettingsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/activity-settings`;
  const requestOptions = options;
  return client.put<UpdateActivitySettingsResponse>(requestPath, data, requestOptions);
}
